const formatter = new Intl.DateTimeFormat('ro-RO', { day: '2-digit', month: 'long', year: 'numeric' });

/** "2026-10-16T09:12:00.000Z" -> "16 octombrie 2026"; '' pentru null/invalid. */
export function formatRoDate(iso) {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return formatter.format(date);
}
